import { DatePicker } from '@optools/components/datetime/date-picker';
import { GameSchedule } from '@optools/components/game-schedule';
import { BTCGameCard } from '@optools/tools/btc-tools/components/btc-game-card';
import { useBtcScheduleContext } from '@optools/tools/btc-tools/context/btc-schedule-context';
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/btc-tools/schedule/')({
  component: RouteComponent,
});

export function RouteComponent() {
  const { date } = useSearch({ from: '/_auth/btc-tools/schedule' });
  const navigate = useNavigate({ from: Route.fullPath });
  const handleDateChange = (newDate: string) => {
    return navigate({ search: (search) => ({ ...search, date: newDate }) });
  };

  const { loading, schedule } = useBtcScheduleContext();

  return (
    <GameSchedule
      loading={loading}
      render={(game) => <BTCGameCard key={game.gamePk} date={date} game={game} />}
      schedule={schedule}>
      <DatePicker date={date} disabled={loading} setDate={handleDateChange} />
    </GameSchedule>
  );
}
